import { useQuery } from '@tanstack/react-query';
import QueryKeys from '@constants/queryKeys';
import { MINUTE } from '@constants/various';
import useNotification from '@hooks/useNotification';
import { getOtherNotifications } from '@worker/services/inbox/api';
import type { FetchNotificationsParams } from '@th-types/worker-notifications.type';

interface UseWorkerOtherNotificationsOptions {
  enabled?: boolean;
  showErrorToast?: boolean;
}

export function useWorkerOtherNotifications(
  params: FetchNotificationsParams,
  options?: UseWorkerOtherNotificationsOptions
) {
  const { showErrorNotification } = useNotification();
  const showErrorToast = options?.showErrorToast ?? true;

  return useQuery({
    queryKey: [
      QueryKeys.WorkerInbox.OTHER_NOTIFICATIONS,
      params.offset,
      params.max,
      params.dateFrom,
      params.dateTo,
    ],
    queryFn: async () => {
      try {
        return await getOtherNotifications(params);
      } catch (error) {
        if (showErrorToast) {
          showErrorNotification('Could not load notifications.');
        }
        throw error;
      }
    },
    staleTime: MINUTE,
    retry: false,
    enabled: options?.enabled ?? true,
  });
}
